import { createContext, useContext } from 'react'
import { type HubspotWorkflowViewStore } from 'pages/hubspotWorkflows/ui/hubspotWorkflowView'

export const HubspotWorkflowViewContext = createContext<HubspotWorkflowViewStore | null>(null)

export const useHubspotWorkflowViewContext = () => {
  const context = useContext(HubspotWorkflowViewContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with HubspotWorkflowViewContext'
    )

  return context
}
